module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-bg-video"
  }, [_c('div', {
    staticClass: "custom-bg-video__container"
  }, [_c('video', {
    ref: "video",
    staticClass: "custom-bg-video__video",
    attrs: {
      "loop": "loop",
      "muted": "muted",
      "autoplay": "autoplay",
      "poster": _vm.props.poster,
      "aria-hidden": "true"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.bg_video,
      "type": "video/mp4"
    }
  }), _vm._v("Your browser does not support video. :face_with_hand_over_mouth:")])]), _c('div', {
    staticClass: "custom-bg-video__title-box"
  }, [_c('div', {
    staticClass: "custom-bg-video__title"
  }, [_c('h1', {
    staticClass: "hero"
  }, [_vm._v(_vm._s(_vm.props.hero.title))]), (_vm.props.hero.button.true) ? _c('div', {
    staticClass: "custom-bg-video__button",
    on: {
      "click": function($event) {
        _vm.openVideo()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.props.hero.button.text))]), _c('Icon', {
    attrs: {
      "name": "carrot"
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f2a0d80","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-bg-video/custom-bg-video.pug
// module id = 587
// module chunks = 1